var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v("Crear nuevo usuario"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.CREATE()
                      },
                    },
                  },
                  [
                    _vm.count == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Guardar")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c("div", { staticClass: "container-fluid vstack gap-5" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Tipo de cuenta"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.account_type ? "is-invalid" : "",
                    attrs: { items: _vm.accounts, "hide-details": "" },
                    on: { change: _vm.CHANGE },
                    model: {
                      value: _vm.data.account_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "account_type", $$v)
                      },
                      expression: "data.account_type",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.account_type, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _vm.data.account_type == 2
                ? _c(
                    "div",
                    { staticClass: "form-group mb-2" },
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Nombre de la Empresa"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.company,
                            expression: "data.company",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.company ? "is-invalid" : "",
                        attrs: { type: "text" },
                        domProps: { value: _vm.data.company },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.data, "company", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.company, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Tipo de Identificación"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.identification_type ? "is-invalid" : "",
                    attrs: {
                      items: _vm.identifications.filter(function (e) {
                        return _vm.data.account_type == 2
                          ? e.value == 2
                          : e.value != 2
                      }),
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.data.identification_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "identification_type", $$v)
                      },
                      expression: "data.identification_type",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(
                    _vm.errors.identification_type,
                    function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.data.account_type == 2
                          ? "Cédula Jurídica"
                          : "Identificación"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: _vm.format,
                        expression: "format",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.identification,
                        expression: "data.identification",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.identification ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.identification },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.data,
                          "identification",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.identification, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.data.account_type == 2
                    ? _c("small", [
                        _vm._v(
                          "Ejemplo: Si es 3-101-123456 se debe digitar 3101123456"
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm.data.account_type != 2
                ? _c(
                    "div",
                    { staticClass: "form-group mb-2" },
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Nombre"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.first_name,
                            expression: "data.first_name",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.first_name ? "is-invalid" : "",
                        attrs: { type: "text" },
                        domProps: { value: _vm.data.first_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "first_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.first_name, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm.data.account_type != 2
                ? _c(
                    "div",
                    { staticClass: "form-group mb-2" },
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Apellido"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.last_name,
                            expression: "data.last_name",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.last_name ? "is-invalid" : "",
                        attrs: { type: "text" },
                        domProps: { value: _vm.data.last_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.data, "last_name", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.last_name, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm.$route.params.role == "warehouses"
                ? _c(
                    "div",
                    { staticClass: "form-group mb-2" },
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Bodega"),
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.warehouse_id ? "is-invalid" : "",
                        attrs: {
                          items: _vm.warehouses,
                          "item-text": function (item) {
                            return item.code + "-" + item.name
                          },
                          "item-value": "id",
                          "hide-details": "",
                          "no-data": "",
                        },
                        model: {
                          value: _vm.data.warehouse_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "warehouse_id", $$v)
                          },
                          expression: "data.warehouse_id",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.warehouse_id, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Correo Electrónico"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.email,
                        expression: "data.email",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.email ? "is-invalid" : "",
                    attrs: { type: "email" },
                    domProps: { value: _vm.data.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "email", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.email, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c("div", { staticClass: "form-group mb-2" }, [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Descuento: "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group input-group-sm" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.discount,
                          expression: "data.discount",
                        },
                      ],
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.discount ? "is-invalid" : "",
                      attrs: { type: "text" },
                      domProps: { value: _vm.data.discount },
                      on: {
                        keypress: _vm.DOUBLE,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "discount", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          "\n                                        %\n                                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.errors.discount, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Precio por libra: "),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.price_per_pound,
                        expression: "data.price_per_pound",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.price_per_pound ? "is-invalid" : "",
                    attrs: { type: "text", placeholder: "0" },
                    domProps: { value: _vm.data.price_per_pound },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.data,
                          "price_per_pound",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.price_per_pound, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.data.price_per_pound > 0
              ? _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group mb-2" },
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Monto minimo facturable: "),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.minimum_billable_amount,
                            expression: "data.minimum_billable_amount",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.minimum_billable_amount
                          ? "is-invalid"
                          : "",
                        attrs: { type: "text", placeholder: "0" },
                        domProps: { value: _vm.data.minimum_billable_amount },
                        on: {
                          keypress: _vm.DOUBLE,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "minimum_billable_amount",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.errors.minimum_billable_amount,
                        function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }